import { InjectionToken } from '@angular/core';

/** Uniform fraction in [0, 1) behind a token, so specs can pin every random delay. */
export const RANDOM_FRACTION = new InjectionToken<() => number>('RANDOM_FRACTION', {
  providedIn: 'root',
  factory: () => () => Math.random(),
});

/** A delay in [0, maxMs) that keeps many tabs from firing in the same instant. */
export function randomDelayMs(randomFraction: () => number, maxMs: number): number {
  return Math.floor(randomFraction() * maxMs);
}

/** `baseMs` moved by up to ±`ratio` of itself (0.3 → 70 %–130 %). */
export function spreadDelayMs(randomFraction: () => number, baseMs: number, ratio: number): number {
  return Math.round(baseMs * (1 + (2 * randomFraction() - 1) * ratio));
}
